import { render } from "./tttGameGrid.vue?vue&type=template&id=f2ba16d4&scoped=true"
import script from "./tttGameGrid.vue?vue&type=script&lang=js"
export * from "./tttGameGrid.vue?vue&type=script&lang=js"

import "./tttGameGrid.vue?vue&type=style&index=0&id=f2ba16d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ba16d4"]])

export default __exports__